import React from 'react';

import { Text } from './text';
import { TextProps } from './text.props';
import { types } from './text.types';
import { elements } from './text.elements';

export const H1 = (props: TextProps) => (
  <Text type={types.h1} element={elements.h1} {...props} />
);
export const H2 = (props: TextProps) => (
  <Text type={types.h2} element={elements.h2} {...props} />
);
export const H3 = (props: TextProps) => (
  <Text type={types.h3} element={elements.h3} {...props} />
);
export const H4 = (props: TextProps) => (
  <Text type={types.h4} element={elements.h4} {...props} />
);
export const H5 = (props: TextProps) => (
  <Text type={types.h5} element={elements.h5} {...props} />
);
export const H6 = (props: TextProps) => (
  <Text type={types.h6} element={elements.h6} {...props} />
);

export const Inline = (props: TextProps) => (
  <Text element="span" margin={0} {...props} />
);
